import {Select} from "antd";

import styles from "./select-field.module.scss";

const {Option} = Select;

const SelectField = ({handleChange, options, placeholder}) => {

    const elements = options.map(({id, value, text}) => <Option key={id} value={value}>{text}</Option>)

    return (
        <Select
            mode="multiple"
            allowClear
            style={{
                width: '100%',
            }}
            placeholder={placeholder}
            onChange={handleChange}
        >
            {elements}
        </Select>
    )
}

export default SelectField;